"use client";

import { CreditUsageModal } from "@/component/CreditUsageModal";
import { InviteGuideModal } from "@/component/InviteGuideModal";
import { userStore } from "@/store/user";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Header } from "./index";

export const HeaderContainer = observer(() => {
  const user = userStore.user;
  const userPlan = userStore.userPlan;
  const userCredits = userStore.userCredits;
  const userLoading = userStore.loading;
  const [creditModalOpen, setCreditModalOpen] = useState(false);
  const [inviteModalOpen, setInviteModalOpen] = useState(false);

  const handleCreditUsageClick = () => {
    setCreditModalOpen(true);
  };

  return (
    <>
      <Header
        user={user}
        userPlan={userPlan}
        isGifted={userStore.isDisplayPlanGifted}
        userCredits={userCredits}
        userLoading={userLoading}
        onCreditUsageClick={handleCreditUsageClick}
        onInviteClick={() => setInviteModalOpen(true)}
      />
      <CreditUsageModal
        open={creditModalOpen}
        onClose={() => setCreditModalOpen(false)}
        mode="account"
      />
      <InviteGuideModal
        open={inviteModalOpen}
        onClose={() => setInviteModalOpen(false)}
      />
    </>
  );
});
